import { gql } from "@apollo/client";

const SALES_PERSON_SPLIT_FIELDS = `
  id
  salesUserId
  split
  timestamp
`;

const OFFER_SELLING_PEOPLE_NAME_FIELDS = `
  offerSalesPeople {
    id
    split
    salesUser {
      id
      name
    }
  }
`;

const FETCH_OFFER_SALES_PEOPLE = gql`
  query FetchOfferSalesPeople($id: Int) {
    offer(id: $id) {
      id
      offerSalesPeople {
        ${SALES_PERSON_SPLIT_FIELDS}
      }
    }
  }
`;

export {
  FETCH_OFFER_SALES_PEOPLE,
  OFFER_SELLING_PEOPLE_NAME_FIELDS,
  SALES_PERSON_SPLIT_FIELDS,
};
